//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'

const StyledSidebarTabs = styled.div`
  display: flex;
  padding: 10px 0 0 0;
  user-select: none;
  margin-left: -16px;
`

const Tab = styled.div`
  padding: 4px 8px 0 8px;
  color: ${colors.secondary40};
  cursor: pointer;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;

  &:hover {
    color: ${colors.primary35};
  }

  ${props => props.active && css`
    color: ${colors.primary35};
    border-bottom: 2px solid ${colors.primary35};
  `}
`

const SidebarTabs = ({ tabs, activeTabId, onTabChange }) => {
  return (
    <StyledSidebarTabs>
      {tabs.map(tab => {
        const isActive = Boolean(activeTabId === tab.id)
        return (
          <Tab
            key={tab.id}
            onClick={(e) => onTabChange(tab)}
            active={isActive}
            data-test={tab.id}
          >
            {tab.title}
          </Tab>
        )
      })}
    </StyledSidebarTabs>
  )
}

SidebarTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
    })
  ).isRequired,
  activeTabId: PropTypes.string,
  onTabChange: PropTypes.func.isRequired,
}

export default SidebarTabs
